import { helper } from "@ember/component/helper"
import { parseCover } from "cc-frontend/utils/planbook-covers"
import { getCoverStyles } from "./get-cover-styles"

export default helper(function getPlanbookCoverStyles([cover, loadWidth]: [
  string,
  number | undefined
]) {
  let [background, pattern] = parseCover(cover)
  return getCoverStyles(background, pattern, loadWidth)
})
